module.exports = __webpack_public_path__ + "img/cica80.74100877.jpg";